import { render, staticRenderFns } from "./KPIBox.vue?vue&type=template&id=20cd9678&scoped=true"
import script from "./KPIBox.vue?vue&type=script&lang=js"
export * from "./KPIBox.vue?vue&type=script&lang=js"
import style0 from "./KPIBox.vue?vue&type=style&index=0&id=20cd9678&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cd9678",
  null
  
)

export default component.exports